export const NAV = {
  link: (id) => `nav-link-${id}`,
  cta: "nav-cta-contact",
  logo: "nav-logo",
};

export const HERO = {
  root: "hero-section",
  cta: "hero-cta-work",
  secondary: "hero-cta-contact",
};

export const ABOUT = { root: "about-section" };
export const PROJECTS = {
  root: "projects-section",
  card: (id) => `project-card-${id}`,
};
export const SKILLS = { root: "skills-section" };
export const EXPERIENCE = { root: "experience-section" };
export const BLOG = {
  root: "blog-section",
  card: (id) => `blog-card-${id}`,
  back: "blog-back-link",
};
export const CONTACT = {
  root: "contact-section",
  name: "contact-input-name",
  email: "contact-input-email",
  subject: "contact-input-subject",
  message: "contact-input-message",
  submit: "contact-submit-button",
  success: "contact-success-message",
};
export const FOOTER = { root: "footer-section" };
